/* eslint-disable */
window.PubSub = {
  publish: (type, payload) => {
    console.log(type, payload);
  }
};

var $ = window.$;

window.Refinitiv_pageFunctions = {
  exportXLSCallback: function(rows, format, filterObject) {
    var filterObj = filterObject.filters;
    var sortObj = filterObject.sort;
    var filters = [];
    var sort = [];
    var pagination = {};
    var output = {};
    Object.keys(filterObj).map(function(key, index) {
      filters[index] = {
        type: filterObj[key].type,
        column: filterObj[key].column,
        value: [filterObj[key].values]
      };
    });
    if (filterObject.search) {
      filters.push({
        type: "text",
        column: "tableheadersearch",
        value: [filterObject.search]
      });
    }
    if (filterObject.sort) {
      sort = [
        {
          type: sortObj._type,
          column: sortObj._sort,
          value: [sortObj._order]
        }
      ];
    }

    output.filters = filters;
    output.sort = sort;
    output.pagination = pagination;
    for (var i in output.filters) {
      if (output.filters[i].type === "daterange") {
        var startDate = output.filters[i].value[0].startDate;
        var endDate = output.filters[i].value[0].endDate;
        startDate =
          startDate.getFullYear() +
          "/" +
          (startDate.getMonth() + 1 < 10 ? "0" : "") +
          (startDate.getMonth() + 1) +
          "/" +
          (startDate.getDate() < 10 ? "0" : "") +
          startDate.getDate();
        endDate =
          endDate.getFullYear() +
          "/" +
          (endDate.getMonth() + 1 < 10 ? "0" : "") +
          (endDate.getMonth() + 1) +
          "/" +
          (endDate.getDate() < 10 ? "0" : "") +
          endDate.getDate();
        output.filters[i].value = [startDate, endDate];
        output.filters[i].type = "date_range";
      }
      if (output.filters[i].type === "search") {
        output.filters[i].type = "text";
      }
      if (output.filters[i].type === "list") {
        output.filters[i].type = "value";
        var valueArr = output.filters[i].value[0];
        var updatedValArr = [];
        for (var k in valueArr) {
          updatedValArr.push(valueArr[k].value);
        }
        output.filters[i].value = updatedValArr;
      }
    }
    //    $('.ric-list-form form').find("#body").val(JSON.stringify(output));
    //   $('.ric-list-form form').find("#csrfToken").val(csrftoken);
    // $('.ric-list-form form').find("#submit").click();
  },
  multiSelectComparator: function(rows) {
    return rows;
  },

  multiSelectActionCallback: function(selectedRows) {},
  validateAndShowPopup: function(selectedRows) {
    window.onDownload(selectedRows);
    $("#raiseDownloadRequest").modal("show");
  },

  nestedRowSelection: function(row, callback) {},
  actionBuilder: function(row) {
    return [];
  },
  endpointCallback: function() {
    var filter = $(".tab-header.active").attr("data-tab-type");
    filter = filter[0].toUpperCase();

    const params = {
      accNumber: window.billingaccNumber,
      documentType: filter,
      accType: "single"
    };
    return window.buildRequestURI(window.BILLINGINFODASHBOARD_URI, params);
  },
  flagBuilder: function(row) {
    if (row.status === "Overdue") {
      return "red";
    }

    if (row.status === "Due") {
      return "blue";
    }

    return null;
  },

  cellLinkCallback: function(row) {
    return { callback: "callbackRef" };
  },

  callbackRef: function(dataRow) {
    var ID = dataRow.sequenceId;
    location.href = "symbolchanges/viewdata.html#id=" + ID;
  },

  cellFormatter: function(row, datafield) {
    let output = {};

    if (datafield === "status") {
      output = {};
      if (row[datafield] === "Overdue") {
        output.styling = {
          color: "red"
        };
      } else if (row[datafield] === "Due") {
        output.styling = {
          color: "blue"
        };
      } else {
        output.styling = {
          color: "gray"
        };
      }
    }
    return output;
  },
  getRevisedFlag: function(row) {
    var revisiondate = row.dnrevisiondate;
    if (revisiondate !== "") {
      var cssobj = {};
      cssobj.background = "#ffffff";
      cssobj.flag = "#4d4d4d";
    }
    return cssobj;
  },
  calculateCellFlag: function(row) {
    var revisiondate = row.dnrevisiondate;
    var flagObj = {};
    if (revisiondate !== "") {
      flagObj.value = "Revised";
      flagObj.styles = {};
      flagObj.styles.fontWeight = "bold";
      flagObj.styles.color = "#4d4d4d";
    }
    return flagObj;
  }
};

window.TR_pageFunctions = {
  exportCSVCallback: (rows, rowsFormat) => {
    console.log(
      "Exporting data with " + rows.length + " rows and format " + rowsFormat
    );
  },

  multiSelectComparator: rows => {
    console.log("comparator...");
    let output = [];

    output = rows.filter(item => {
      return item.code === "06296959";
    });

    return output;
  },

  multiSelectActionCallback: selectedRows => {
    console.log(selectedRows);
  },

  nestedRowSelection: (row, callback) => {},

  actionBuilder(row) {
    return {
      type: "button",
      label: "Click",
      callback: "function here"
    };

    /* return {
      type: 'kebab',
      actions: [
      {label: 'Item 1', actionType: 'callback', action: 'sampleKebabCallback'},
      {label: 'Item 2', actionType: 'callback', action: 'sampleKebabCallback'},
      {label: 'Item 3', actionType: 'callback', action: 'sampleKebabCallback'}
      ]
    } */
  },

  flagBuilder: row => {
    if (row.code === "06296841") {
      return "red";
    }

    if (row.code === "06296840") {
      return "blue";
    }

    return null;
  },

  cellLink: row => {
    return "/sample";
  },

  cellFormatter: (row, datafield) => {
    let output = null;

    if (datafield === "code") {
      output = {
        label: {
          content: "LABEL",
          styling: {
            fontWeight: "bold",
            color: "green"
          }
        }
      };
    }

    if (datafield === "status") {
      output = {};
      if (row[datafield] === "New") {
        output.styling = {
          color: "red"
        };
      }
    }
    return output;
  },

  component1: {
    validateAndShowPopup: (rows, minimumSelected) => {
      console.log(rows);
    },

    postLoadCallback: data => {
      // console.log(data)
    },

    exportCSVCallback: (rows, rowsFormat, filterPayload) => {
      console.log(
        "Exporting data with " + rows.length + " rows and format " + rowsFormat
      );
      console.log(filterPayload);
    },

    multiSelectComparator: rows => {
      let output = [];

      output = rows.filter(item => {
        return true; // item.code === '06296959'
      });

      return output;
    },

    multiSelectActionCallback: selectedRows => {
      console.log(selectedRows);
    },

    nestedRowSelection: (row, callback) => {
      return true;
    },

    sampleKebabCallback(row) {
      console.log(row);
    },

    sampleLinkCallback(row) {
      console.log(row);
    },

    actionBuilder(row, checkedState) {
      if(checkedState) {
        return [];
      }
      return [
        {
          type: "kebab",
          actions: [
            {
              label: "Item 1",
              actionType: "callback",
              action: "sampleKebabCallback"
            },
            {
              label: "Item 2",
              actionType: "link",
              action: "http://www.google.com"
            },
            {
              label: "Item 3",
              actionType: "callback",
              action: "sampleKebabCallback"
            }
          ]
        },
       /* {
          actionType: "link",
          type: "link",
          action: "/more_info",
          label: "More"
        }
        {
          actionType: "callback",
          type: "button",
          action: "sampleButtonCallback",
          label: "Buy Something"
        }, */
      ];
    },

    flagBuilder: row => {
      if (row.code === "06296841") {
        return "red";
      }

      if (row.code === "06296840") {
        return "blue";
      }

      return null;
    },

    cellLink: row => {
      return {
        callback: "handleCellLink"
      };
    },

    handleCellLink: row => {
      console.log("CELL CLICK", row);
    },

    cellFormatter: (row, datafield) => {
      let output = null;

      if (datafield === "subject") {
        output = {
          label: {
            content: "LABEL",
            styling: {
              fontWeight: "bold",
              color: "green"
            }
          }
        };
      }

      if (datafield === "countryName") {
        output = {
          label: {
            content: "LABEL",
            styling: {
              fontWeight: "bold",
              color: "green"
            }
          }
        };
      }

      if (datafield === "status") {
        output = {};
        if (row[datafield] === "New") {
          output.styling = {
            color: "red"
          };
        }
      }
      return output;
    },

    titleFormatter: title => {
      let output = null;

      if (title === "Support Cases") {
        output = {
          label: {
            content: "",
            styling: {
              color: "#CCC"
            }
          },
          styling: {
            color: "#555"
          }
        };
      }

      return output;
    }
  },

  datatable1: {
    exportCSVCallback: (rows, rowsFormat) => {
      console.log(
        "Exporting data with " + rows.length + " rows and format " + rowsFormat
      );
    },

    multiSelectComparator: rows => {
      let output = [];

      output = rows.filter(item => {
        return item.code === "06296959";
      });

      return output;
    },

    multiSelectActionCallback: selectedRows => {
      console.log(selectedRows);
    },

    nestedRowSelection: (row, callback) => {},

    actionBuilder(row) {
      /*
      {
        type: 'kebab',
        actions: [
        {label: 'Item 1', actionType: 'callback', action: 'sampleKebabCallback'},
        {label: 'Item 2', actionType: 'link', action: 'http://www.google.com'},
        {label: 'Item 3', actionType: 'callback', action: 'sampleKebabCallback'}
        ]
      },
      {
        actionType: 'link',
        type: 'link',
        action: '/more_info',
        label: 'More'
      },
      */
      return [
        {
          actionType: "callback",
          type: "button",
          action: "sampleButtonCallback",
          label: "Buy"
        }
      ];
    },

    sampleKebabCallback() {
      alert("sampleKebabCallback is called");
    },

    sampleButtonCallback() {
      alert("Buy button is called");
    },

    endpointCallback() {
      alert("EndpointCallback is called");
      return "https://www.mocky.io/v2/5b9ba8123000006000f6b3bd";
    },

    flagBuilder: row => {
      if (row.code === "06296841") {
        return "red";
      }

      if (row.code === "06296840") {
        return "blue";
      }

      return null;
    },

    cellLink: row => {
      return "/sample";
    },

    cellLinkCallback: row => {
      return { callback: "callbackRef" };
    },

    callbackRef(dataRow) {
      alert("cellLink callback function is called");
    },

    cellFormatter: (row, datafield) => {
      let output = null;

      if (datafield === "code") {
        output = {
          label: {
            content: "LABEL",
            styling: {
              fontWeight: "bold",
              color: "green"
            }
          }
        };
      }

      if (datafield === "status") {
        output = {};
        if (row[datafield] === "New") {
          output.styling = {
            color: "red"
          };
        }
      }
      return output;
    }
  }
};
